import { TIME_LEVELS } from "./timeLevels";

// The bar does not start a new period of any level (duplicate time)
export const NO_TIME_WEIGHT = -1;

const transitionWeight = (previousLocalMs, localMs) => {
  const previousDate = new Date(previousLocalMs);
  const date = new Date(localMs);

  for (let levelIndex = TIME_LEVELS.length - 1; levelIndex >= 0; levelIndex -= 1) {
    const { bucket } = TIME_LEVELS[levelIndex];

    if (bucket(previousLocalMs, previousDate) !== bucket(localMs, date)) return levelIndex;
  }

  return NO_TIME_WEIGHT;
};

/**
 * Weight of every bar for the time axis: index of the coarsest TIME_LEVELS
 * level that starts at this bar. Computed once per history and time zone,
 * so pan and zoom only filter by weight.
 *
 * @param {number} count - bars, including future ones right of the last bar
 * @param {(index: number) => number} timeAt - UTC ms of a bar
 * @param {number} barDurationMs - the first bar is compared with one bar before it
 * @param {(utcMs: number) => number} toLocalMs
 * @returns {Int8Array}
 */
export const computeTimeWeights = (count, timeAt, barDurationMs, toLocalMs) => {
  const weights = new Int8Array(count);
  let previousLocalMs = count ? toLocalMs(timeAt(0) - barDurationMs) : 0;

  for (let index = 0; index < count; index += 1) {
    const localMs = toLocalMs(timeAt(index));

    weights[index] = transitionWeight(previousLocalMs, localMs);
    previousLocalMs = localMs;
  }

  return weights;
};
